import React, { useRef } from 'react';
import { endsWith, reduce, toLower } from 'lodash';
import './VideoBanner.scss';

const VideoBanner = ({ video }) => {
    const videoRef = useRef(null);
    const sources = video.sources.map((videoSource, idx) => {
        const supportedSources = ['webp', 'mp4'];
        const videoSourceExtension = reduce(
            supportedSources,
            (acc, supportedSource) => {
                acc = endsWith(toLower(videoSource), supportedSource)
                    ? supportedSource
                    : '';
                return acc;
            },
            ''
        );
        const isSupportedExtension =
            supportedSources.indexOf(videoSourceExtension) !== -1;
        if (isSupportedExtension)
            return (
                <source
                    key={idx}
                    src={videoSource}
                    type={`video/${videoSourceExtension}`}
                />
            );
        return <div key={idx}></div>;
    });

    return (
        <div className='video-banner'>
            <video
                ref={videoRef}
                preload='true'
                poster={video.posterImage}
                width='100%'
                muted={true}
                autoPlay={true}
                loop={true}>
                {sources}
            </video>
        </div>
    );
};

export default VideoBanner;
